// Tooltip.tsx
import React, { FunctionComponent } from 'react';
import { Tooltip, OverlayTrigger, OverlayTriggerProps } from 'react-bootstrap';
import styled from 'styled-components'
import { styles } from '../styles/themes/style'

interface TooltipWrapperProps extends Partial<OverlayTriggerProps> {
  tooltipText: string;
  placement?: 'auto' | 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactElement;
  textAlignment?: string;
  /** White tooltip surface (default is dark theme tooltip). */
  light?: boolean;
}

interface IStyledTooltipStyles {
  $disabled?: boolean,
  $textAlignment?: boolean,
  $light?: boolean,
}

const TooltipWrapper: FunctionComponent<TooltipWrapperProps> = ({ tooltipText, placement, children, textAlignment, light, ...props }) => {
  const renderTooltip = (tooltipProps: any) => (
    <StyledTooltip $disabled={tooltipText.length === 0} $textAlignment={textAlignment} $light={light} {...tooltipProps}>
      {tooltipText}
    </StyledTooltip >
  );

  return (
    <OverlayTrigger
      flip={true}
      placement={placement || 'top-start'}
      delay={{ show: 0, hide: 0 }}
      overlay={renderTooltip}
      {...props}
    >
      {children}
    </OverlayTrigger>
  );
};

const StyledTooltip = styled(Tooltip)<IStyledTooltipStyles>`
  ${({$disabled}) => $disabled && `
    display: none;
  `}

  .tooltip-arrow::before{
    display: none;
  }
  &.tooltip {
    position: fixed;
    z-index: 10000002;
    border-radius: 3px;
    padding: 1px;
    // text-transform: capitalize;
    ${({ $light }) => $light && `
      margin-left: 6px;
      opacity: 1;
    `}
    
    .tooltip-inner {
      padding: ${({ $light }) => ($light ? '6px 8px' : '2px')};
      font-size: 12px;
      line-height: 16px;
      background-color: ${({ $light, theme: { septenaryColor } }) => ($light ? '#fff' : septenaryColor)};
      color: ${({ $light, theme: { secondaryColor } }) => ($light ? styles.colors.black400 : secondaryColor)};
      ${({ $light }) => $light && `
        border: 1px solid ${styles.colors.black200};
        box-shadow: 0 2px 8px rgba(16, 24, 40, 0.12);
        white-space: nowrap;
        max-width: none;
      `}
      ${({$textAlignment}) => $textAlignment && `text-align: ${$textAlignment}; padding: 4px;`}
      // text-transform: capitalize;
    }
`;

export default TooltipWrapper;
